module.exports = {
  email: {
    key: 'email',
    label: 'Email',
  },
  phone: {
    key: 'phone',
    label: 'Phone',
  },
  fax: {
    key: 'fax',
    label: 'Fax',
  },
  pager: {
    key: 'pager',
    label: 'Pager',
  },
  url: {
    key: 'url',
    label: 'URL',
  },
  sms: {
    key: 'sms',
    label: 'SMS',
  },
  other: {
    key: 'other',
    label: 'Other',
  },
};